import React from 'react';
import theme from './PromiseCheckList.module.scss';
import { PromiseCheckListProps } from '.';
import { classnames } from '@/utils/html';

const PromiseCheckList: React.FC<PromiseCheckListProps> = ({ children, className }) => {
    return <div className={classnames(className, theme.list)}>{children}</div>;
};

export default PromiseCheckList;
